import { TAB } from './dataMonitorUtil';

/**
 * 分割グラフと結合グラフのMediatorを相互連携する
 * @param {Array} graphMediator タブごとのGraphMediator配列
 */
export function linkSplitUnionMediators(graphMediator) {
  const splitMediator = graphMediator?.[TAB.SPLIT];
  const unionMediator = graphMediator?.[TAB.UNION];

  if (!splitMediator || !unionMediator) {
    return;
  }

  splitMediator.setLinkedMediators?.([unionMediator]);
  unionMediator.setLinkedMediators?.([splitMediator]);
}

/**
 * 指定タブのグラフがズーム/パン状態かどうかを判定する
 * @param {Array} graphMediator タブごとのGraphMediator配列
 * @param {number} tabId タブID
 * @returns {boolean} 指定タブのグラフがズーム/パン状態の場合はtrue
 */
export function isGraphMediatorZoomedOrPanned(graphMediator, tabId) {
  if (![TAB.SPLIT, TAB.UNION].includes(tabId)) {
    return false;
  }

  const mediator = graphMediator?.[tabId];
  return mediator?.isAnyGraphZoomedOrPanned?.() ?? false;
}
